module.exports = __webpack_public_path__ + "static/img/tc.d6883bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tc.png
// module id = Js/2
// module chunks = 1